import React from 'react';
import {Radio, Stack, styled, Typography} from '@mui/material';

const ItemCardContainer = styled(Stack, {shouldForwardProp: p=>!p.startsWith('$')})`
    border-radius: 8px;
    border: 2px solid ${p=>p.$selected ? p.theme.palette.primary.main : p.theme.palette.grey['400']};
    cursor: pointer;
    &:hover {
        border-color: ${p=>p.theme.palette.primary.dark};
    }
    transition: border 300ms ease-out;
    padding-left: 18px;
`;

const ItemCard = props=>{
    let {selected, onClick, label} = props;
    return <ItemCardContainer $selected={selected}
      direction="row" alignItems="center"
      padding={1} onClick={onClick}>
      <Radio checked={selected} onChange={onClick}/>
      <Typography>{label}</Typography>
    </ItemCardContainer>;
};

const RadioCards = props=>{
    let {value, onChange, items, label} = props;
    return <Stack direction="column" gap={1}>
      {label&&<Typography fontWeight="bold">{label}</Typography>}
      <Stack direction="row" gap={2} alignItems="center" flexWrap="wrap">
        {items.map(item=><ItemCard key={item.value}
          selected={item.value==value}
          onClick={()=>onChange(item.value)}
          label={item.label}/>)}
      </Stack>
    </Stack>;
};

export default RadioCards;
